import React from "react";
import { useState } from "react";
import './Cashback.css';
import {
  ArrowRight,
  ArrowUpRight,
  ArrowDown,
  Info,
  X,
  Search,
  Calendar,
  Check,
  Pause,
  Trash2,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronDown,
  Smartphone,
  Users,
  RotateCcw,
  Sprout,
  Zap,
  ShieldAlert,
  Wallet,
  TrendingUp,
  Moon,
  CreditCard,
  Wrench,
  Clock,
  CheckCircle2,
  Car,
  Umbrella,
  Droplet,
  Gift,
  ShoppingCart,
  Coins,
} from "lucide-react";
import {
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  ComposedChart,
  Line,
} from "recharts";
import { FiMoreVertical } from "react-icons/fi";
import "react-circular-progressbar/dist/styles.css";
import TotalVouchersIcon from "../../../assets/svg/State Icons 4.svg";
import RevenueIcon from "../../../assets/svg/Group 163020.svg";
import ConversionRate from "../../../assets/svg/shopping-cart (5) 1 (1).svg";
import AverageBundlePriceIcon from "../../../assets/svg/wallet (1) 1 (2).svg";
import ActiveIcon from "../../../assets/svg/Vector (1).svg";
import ScheduledIcon from "../../../assets/svg/calendar 1.svg";
import DraftIcon from "../../../assets/svg/draft 1.svg";
import UnderReviewIcon from "../../../assets/svg/clock (3) 1.svg";
import PausedIcon from "../../../assets/svg/pause-circle-svgrepo-com 1.svg";
import ApprovedIcon from "../../../assets/svg/shield-check-svgrepo-com 1 (1).svg";
import ExpiredIcon from "../../../assets/svg/support 1.svg";
import ArchivedIcon from "../../../assets/svg/Archived.svg";
import OmarAvatar from "../../../assets/svg/alert2 1.svg";
// cashback performance icons
import issued from "../../../assets/svg/coins-solid-svgrepo-com 1.svg";
import redeemed from "../../../assets/svg/Frame 2147223903.svg";
import rate from "../../../assets/svg/trend 1 (1).svg";
import outstanding from "../../../assets/svg/clock (3) 1 (1).svg";
import liability from "../../../assets/svg/Vector (4).svg";
import { useNavigate } from "react-router";

export default function Cashback() {

  const navigate = useNavigate();

  // stats
  const stats = [
    {
      title: "Total Cashback Campaigns",
      value: "256",
      icon: TotalVouchersIcon,
      bg: "#000000",
      iconColor: "#FFFFFF",
      trend: "+18%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
    {
      title: "Unique Customers Rewarded",
      value: "45,680",
      icon: RevenueIcon,
      bg: "#000000",
      iconColor: "#FFFFFF",
      trend: "+18%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
    {
      title: "Avg. Cashback per Order",
      value: "46.75 EGP",
      icon: ConversionRate,
      bg: "#000000",
      iconColor: "#FFFFFF",
      trend: "+18%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
    {
      title: "Avg. Cashback Cost",
      value: "3.12 EGP",
      icon: AverageBundlePriceIcon,
      bg: "#000000",
      iconColor: "#FFFFFF",
      trend: "+18%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
    {
      title: "Active",
      value: "148",
      icon: ActiveIcon,
      bg: "#3FBEAC",
      iconColor: "#14B8A6",
      trend: "+8%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
    {
      title: "Scheduled",
      value: "28",
      icon: ScheduledIcon,
      bg: "#7E1BAD",
      iconColor: "#A855F7",
      trend: "+14%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
    {
      title: "Draft",
      value: "34",
      icon: DraftIcon,
      bg: "#8CB369",
      iconColor: "#65A30D",
      trend: null,
      trendType: "neutral",
      subtitle: "In progress",
    },
    {
      title: "Under Review",
      value: "18",
      icon: UnderReviewIcon,
      bg: "#FEB91E",
      iconColor: "#F59E0B",
      trend: null,
      trendType: "neutral",
      subtitle: "In review",
    },
    {
      title: "Paused",
      value: "6",
      icon: PausedIcon,
      bg: "#FC6C4F",
      iconColor: "#F43F5E",
      trend: "-9%",
      trendType: "down",
      subtitle: "vs last 30 days",
    },
    {
      title: "Approved",
      value: "42",
      icon: ApprovedIcon,
      bg: "#3E9FF6",
      iconColor: "#FFFFFF",
      trend: "8%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
    {
      title: "Expired",
      value: "46",
      icon: ExpiredIcon,
      bg: "#696969",
      iconColor: "#FFFFFF",
      trend: "-5%",
      trendType: "down",
      subtitle: "vs last 30 days",
    },
    {
      title: "Archived",
      value: "12",
      icon: ArchivedIcon,
      bg: "#04B22E",
      iconColor: "#FFFFFF",
      trend: "9%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
  ];

  // Bundles Performance
  const bundlesPerformance = [
    {
      title: "Total Cashback Issued",
      value: "1,248.750 EGP",
      icon: issued,
      trend: "+18%",
      color: "#ECF9F7",
    },
    {
      title: "Total Cashback Redeemed",
      value: "862,300 EGP",
      icon: redeemed,
      trend: "+18%",
      color: "#F4F8F0",
    },
    {
      title: "Redemption Rate",
      value: "69.1%",
      icon: rate,
      trend: "+18%",
      color: "#F0F8FF",
    },
    {
      title: "Outstanding Liability",
      value: "386,450 EGP",
      icon: outstanding,
      trend: "+18%",
      color: "#FFFAEA",
    },
    {
      title: "Customer Wallet Liability",
      value: "3,176,340 EGP",
      icon: liability,
      trend: "+18%",
      color: "#04B22E1A",
    },
  ];

  // filters
  const [isFiltersOpen, setIsFiltersOpen] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const [filters, setFilters] = useState({
    category: "All Categories",
    type: "All Types",
    fundingSource: "All Sources",
    wallet: "All",
    credit: "All",
    approval: "All",
    expired: "All",
    near: "Min - Max",
    dateRange: "May 01, 2025 - May 31, 2025",
  });

  const filterFieldsRow1 = [
    { key: "type", label: "Campaign Type", value: filters.type },
    { key: "category", label: "Category", value: filters.category },
    {
      key: "fundingSource",
      label: "Funding Source",
      value: filters.fundingSource,
    },
    { key: "wallet", label: "Wallet Type", value: filters.wallet },
    {
      key: "credit",
      label: "Auto Credit",
      value: filters.credit,
    },
  ];

  const filterFieldsRow2 = [
    { key: "approval", label: "Approval Status", value: filters.approval },
    { key: "expired", label: "Expired Soon", value: filters.expired },
    { key: "near", label: "Near Budget Limit", value: filters.near },
  ];

  const handleClearAll = () => {
    setFilters({
      category: "All Categories",
      type: "All Types",
      fundingSource: "All Sources",
      providers: "All Providers",
      assignmentType: "All Assignments",
      priority: "All Priorities",
      createdBy: "All Users",
      priceRange: "Min - Max",
      revenueRange: "Min - Max",
      conversionRate: "Min % - Max %",
      dateRange: "May 01, 2025 - May 31, 2025",
    });
    setSearchTerm("");
  };

  // table & tabs
  const voucherTabs = [
    { key: "all", label: "All Campaigns", count: 256 },
    { key: "active", label: "Active", count: 148 },
    { key: "scheduled", label: "Scheduled", count: 28 },
    { key: "draft", label: "Draft", count: 34 },
    { key: "underReview", label: "Under Review", count: 18 },
    { key: "paused", label: "Paused", count: 6 },
    { key: "expired", label: "Expired", count: 46 },
    { key: "disabled", label: "Disabled", count: 12 },
  ];

  const statusStyles = {
    Active: { bg: "#E6F7F4", color: "#14B8A6" },
    Scheduled: { bg: "#F3E8FF", color: "#A855F7" },
    Draft: { bg: "#EFFCE9", color: "#65A30D" },
  };

  const vouchersData = [
    {
      id: "PRM-001",
      name: "Welcome 20% Off",
      code: "Welcome 20%",
      type: "Percentage",
      discount: "20% OFF",
      assignedTo: "All Customers",
      redemptionUsed: 1245,
      redemptionLimit: 5000,
      validity: "Mar 10 - May 31, 2025",
      status: "Active",
      lastUpdate: "2h ago",
      updatedBy: "Mona Ali",
    },
    {
      id: "PRM-002",
      name: "Ramadan Special 25%",
      code: "RAMADAN25",
      type: "Percentage",
      discount: "25% OFF",
      assignedTo: "VIP Customers",
      redemptionUsed: 2890,
      redemptionLimit: 10000,
      validity: "Mar 20 - Jun 20, 2025",
      status: "Scheduled",
      lastUpdate: "2h ago",
      updatedBy: "Mona Ali",
    },
    {
      id: "PRM-003",
      name: "Free Shipping",
      code: "FREESHIP",
      type: "Fixed amount",
      discount: "Free Shipping",
      assignedTo: "All Customers",
      redemptionUsed: 856,
      redemptionLimit: null,
      validity: "Mar 01 - May 31, 2025",
      status: "Active",
      lastUpdate: "3h ago",
      updatedBy: "Mona Ali",
    },
    {
      id: "PRM-004",
      name: "New User 15% Off",
      code: "NEWUSER15",
      type: "Percentage",
      discount: "15% OFF",
      assignedTo: "New Customers",
      redemptionUsed: 562,
      redemptionLimit: 2000,
      validity: "-",
      status: "Draft",
      lastUpdate: "1d ago",
      updatedBy: "Mona Ali",
    },
  ];

  const [activeVoucherTab, setActiveVoucherTab] = useState("all");
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [voucherPage, setVoucherPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const totalVouchersCount = 256;

  const filteredVouchers =
    activeVoucherTab === "all"
      ? vouchersData
      : vouchersData.filter(
          (v) => v.status.toLowerCase() === activeVoucherTab.toLowerCase(),
        );

  const totalPages = Math.max(1, Math.ceil(totalVouchersCount / perPage));

  const startIndex = (voucherPage - 1) * perPage;

  const currentPageData = filteredVouchers.slice(
    startIndex,
    startIndex + perPage,
  );

  const allSelected =
    currentPageData.length > 0 &&
    currentPageData.every((v) => selectedRows.has(v.id));

  const toggleRow = (id) => {
    setSelectedRows((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const toggleSelectAll = () => {
    setSelectedRows((prev) => {
      const next = new Set(prev);
      if (allSelected) {
        currentPageData.forEach((v) => next.delete(v.id));
      } else {
        currentPageData.forEach((v) => next.add(v.id));
      }
      return next;
    });
  };

  const getPageNumbers = (current, total) => {
    const pages = [];
    if (total <= 5) {
      for (let i = 1; i <= total; i++) pages.push(i);
      return pages;
    }
    pages.push(1, 2, 3, "...", total);
    return pages;
  };

  const pageNumbers = getPageNumbers(voucherPage, totalPages);
  const activeTabLabel =
    voucherTabs.find((t) => t.key === activeVoucherTab)?.label ||
    "All Vouchers";

  const buildConicGradient = (segments) => {
    let acc = 0;
    const stops = segments.map((s) => {
      const start = acc;
      acc += s.pct;
      return `${s.color} ${start}% ${acc}%`;
    });
    return `conic-gradient(${stops.join(", ")})`;
  };

  const campaignStatusData = [
    { label: "Active", count: 148, pct: 57.8, color: "#3FBEAC" },
    { label: "Scheduled", count: 34, pct: 10.9, color: "#7E1BAD" },
    { label: "Draft", count: 34, pct: 13.3, color: "#8CB369" },
    { label: "Under Review", count: 18, pct: 7.0, color: "#FEB91E" },
    { label: "Paused", count: 7, pct: 2.3, color: "#FC6C4F" },
    { label: "Expired", count: 19, pct: 6.2, color: "#696969" },
    { label: "Approved", count: 12, pct: 4.7, color: "#3E9FF6" },
    { label: "Archived", count: 3, pct: 1.2, color: "#04B22E" },
  ];

  const campaignStatusTotal = 312;

  // Campaign Health
  const campaignHealthData = [
    {
      icon: ShieldAlert,
      iconBg: "#FFFAEA",
      iconColor: "#F59E0B",
      title: "Budget Risk",
      desc: "% of campaigns near or over budget",
      badge: "Medium",
      badgeBg: "#FFFAEA",
      badgeColor: "#B45309",
      barColor: "#F59E0B",
      barWidth: 28,
      fraction: "87 of 312 campaigns",
      pctLabel: "28%",
    },
    {
      icon: ShieldAlert,
      iconBg: "#FFF4F0",
      iconColor: "#DC2626",
      title: "Fraud Risk",
      desc: "% of campaigns flagged for unusual activity",
      badge: "Low",
      badgeBg: "#FFF4F0",
      badgeColor: "#DC2626",
      barColor: "#DC2626",
      barWidth: 8,
      fraction: "25 of 312 campaigns",
      pctLabel: "8%",
    },
    {
      icon: Wallet,
      iconBg: "#ECF9F7",
      iconColor: "#14B8A6",
      title: "Budget Risk",
      desc: "% of issued cashback that has been redeemed",
      badge: "Good",
      badgeBg: "#ECFDF5",
      badgeColor: "#16A34A",
      barColor: "#14B8A6",
      barWidth: 95,
      fraction: "1,789,000 EGP of 2,186,000 EGP",
      pctLabel: "28%",
    },
  ];

  // Top Cashback Categories (donut)
  const topCategoriesData = [
    { label: "Maintenance", pct: 33.3, color: "#8CB369" },
    { label: "Car Care", pct: 23.8, color: "#3E9FF6" },
    { label: "Oil", pct: 17.1, color: "#FEB91E" },
    { label: "Tires", pct: 11.4, color: "#696969" },
    { label: "Batteries", pct: 10.8, color: "#FC6C4F" },
  ];

  // 4 metric cards
  const cashbackMetricCards = [
    {
      icon: Wallet,
      bg: "#F6E9FC",
      iconColor: "#7E1BAD",
      title: "Near Budget",
      count: "12",
      trend: "5%",
      trendType: "up",
    },
    {
      icon: TrendingUp,
      bg: "#ECF9F7",
      iconColor: "#14B8A6",
      title: "High Redemption",
      count: "18",
      trend: "7%",
      trendType: "up",
    },
    {
      icon: ShieldAlert,
      bg: "#FFF4F0",
      iconColor: "#DC2626",
      title: "Fraud Alerts",
      count: "4",
      trend: "2%",
      trendType: "down",
    },
    {
      icon: Moon,
      bg: "#F0F8FF",
      iconColor: "#3E9FF6",
      title: "Dormant Campaign",
      count: "9",
      trend: "3%",
      trendType: "up",
    },
  ];

  // Cashback Abuse Detection table
  const abuseDetectionData = [
    {
      icon: CreditCard,
      bg: "#FDF2F8",
      iconColor: "#DB2777",
      type: "Same Card",
      desc: "Multiple accounts using the same payment card",
      cases: 15,
      trendPct: "2%",
      riskLevel: "High",
      riskBg: "#FFF4F0",
      riskColor: "#DC2626",
    },
    {
      icon: Smartphone,
      bg: "#F6E9FC",
      iconColor: "#7E1BAD",
      type: "Same Device",
      desc: "Multiple accounts accessed from the same device",
      cases: 12,
      trendPct: "2%",
      riskLevel: "Medium",
      riskBg: "#FFFAEA",
      riskColor: "#B45309",
    },
    {
      icon: Users,
      bg: "#F0F8FF",
      iconColor: "#3E9FF6",
      type: "Multiple Accounts",
      desc: "Multiple accounts created by the same user",
      cases: 8,
      trendPct: "2%",
      riskLevel: "High",
      riskBg: "#FFF4F0",
      riskColor: "#DC2626",
    },
    {
      icon: RotateCcw,
      bg: "#FFFAEA",
      iconColor: "#F59E0B",
      type: "Refund Abuse",
      desc: "Cashback earned on orders that were refunded",
      cases: 5,
      trendPct: "2%",
      riskLevel: "Medium",
      riskBg: "#FFFAEA",
      riskColor: "#B45309",
    },
    {
      icon: Sprout,
      bg: "#ECF9F7",
      iconColor: "#14B8A6",
      type: "Cashback Farming",
      desc: "Abnormal pattern of creating orders to earn cashback",
      cases: 3,
      trendPct: "2%",
      riskLevel: "High",
      riskBg: "#FFF4F0",
      riskColor: "#DC2626",
    },
    {
      icon: Zap,
      bg: "#F4F8F0",
      iconColor: "#8CB369",
      type: "High Frequency Users",
      desc: "Users with unusually high transaction frequency",
      cases: 9,
      trendPct: "2%",
      riskLevel: "Medium",
      riskBg: "#FFFAEA",
      riskColor: "#B45309",
    },
  ];

  // Recent Activity table
  const cashbackRecentActivity = [
    {
      avatar: OmarAvatar,
      user: "Omar Ahmed",
      role: "Admin",
      action: "Created Campaign",
      campaign: "Summer Cashback",
      date: "Jun 15, 2025",
      time: "10:30 am",
      source: "Portal",
      details: "Campaign created with 10% cashback, Budget 500K EGP",
    },
    {
      avatar: OmarAvatar,
      user: "Omar Ahmed",
      role: "Admin",
      action: "Approved Campaign",
      campaign: "Fuel Cashback",
      date: "Jun 15, 2025",
      time: "10:30 am",
      source: "System",
      details: "Campaign approved and moved to Scheduled",
    },
    {
      avatar: OmarAvatar,
      user: "Omar Ahmed",
      role: "Admin",
      action: "Cashback Credited",
      campaign: "Weekend Cashback",
      date: "Jun 15, 2025",
      time: "10:30 am",
      source: "System",
      details: "1,250 customers credited with EGP 45,000",
    },
    {
      avatar: OmarAvatar,
      user: "Omar Ahmed",
      role: "Admin",
      action: "Settlement Completed",
      campaign: "Grocery Cashback",
      date: "Jun 15, 2025",
      time: "10:30 am",
      source: "System",
      details: "Provider settlement completed for EGP 185,000",
    },
    {
      avatar: OmarAvatar,
      user: "Omar Ahmed",
      role: "Admin",
      action: "Campaign Expired",
      campaign: "Spring Cashback",
      date: "Jun 15, 2025",
      time: "10:30 am",
      source: "System",
      details: "Campaign expired. Remaining liability: EGP 12,500",
    },
  ];

  // Top Performing Campaigns (right column list)
  const topPerformingCampaignsList = [
    {
      icon: Car,
      bg: "#EFF6FF",
      iconColor: "#3E9FF6",
      name: "10% Cashback on Maintenance",
      amount: "125,000 EGP",
      pct: "68.8%",
    },
    {
      icon: Umbrella,
      bg: "#FFF7ED",
      iconColor: "#F59E0B",
      name: "Weekend Wallet Boost",
      amount: "98,000 EGP",
      pct: "69.3%",
    },
    {
      icon: Droplet,
      bg: "#FFFAEA",
      iconColor: "#F59E0B",
      name: "Oil Change Reward",
      amount: "88,000 EGP",
      pct: "61.5%",
    },
    {
      icon: Droplet,
      bg: "#FFFAEA",
      iconColor: "#F59E0B",
      name: "Oil Change Reward",
      amount: "88,000 EGP",
      pct: "61.5%",
    },
    {
      icon: Gift,
      bg: "#FFF4F0",
      iconColor: "#DC2626",
      name: "Battery Cashback",
      amount: "64,000 EGP",
      pct: "66.6%",
    },
  ];

  // Wallet Funnel
  const walletFunnelData = [
    { label: "Issued", amount: "2,180,000 EGP", pct: 100, color: "#14B8A6" },
    { label: "Credited", amount: "1,742,000 EGP", pct: 79.9, color: "#3E9FF6" },
    {
      label: "Available",
      amount: "1,285,000 EGP",
      pct: 58.9,
      color: "#7E1BAD",
    },
    { label: "Redeemed", amount: "1,085,000 EGP", pct: 49.8, color: "#8CB369" },
    { label: "Expired", amount: "142,000 EGP", pct: 6.5, color: "#FEB91E" },
    { label: "Reversed", amount: "95,000 EGP", pct: 4.4, color: "#FC6C4F" },
  ];

  const walletFunnelWidths = [
    100,
    85,
    70,
    55,
    40,
    25,
  ];

  // Settlement Overview
  const settlementOverviewData = [
    {
      letter: "T",
      bg: "#F1F1F1",
      iconColor: "#4B5563",
      title: "Platform Share",
      amount: "1,125,000 EGP",
      pct: 48,
      barColor: "#3E9FF6",
    },
    {
      icon: Wrench,
      bg: "#F6E9FC",
      iconColor: "#7E1BAD",
      title: "Provider Share",
      amount: "1,055,000 EGP",
      pct: 45,
      barColor: "#3E9FF6",
    },
    {
      icon: Clock,
      bg: "#FFFAEA",
      iconColor: "#F59E0B",
      title: "Pending Settlement",
      amount: "235,000 EGP",
      pct: 10,
      barColor: "#DC2626",
    },
    {
      icon: CheckCircle2,
      bg: "#ECF9F7",
      iconColor: "#14B8A6",
      title: "Completed Settlement",
      amount: "1,945,000 EGP",
      pct: 85,
      barColor: "#14B8A6",
    },
  ];


  const redemptionTrendData = [
    {
      date: "Apr 28",
      issued: 50000,
      redeemed: 108000,
      refunded: 70000,
      pending: 35000,
      expired: 18000,
      reversed: 2000,
    },
    {
      date: "May 01",
      issued: 75000,
      redeemed: 128000,
      refunded: 95000,
      pending: 36000,
      expired: 18000,
      reversed: 3000,
    },
    {
      date: "May 05",
      issued: 58000,
      redeemed: 115000,
      refunded: 80000,
      pending: 45000,
      expired: 28000,
      reversed: 12000,
    },
    {
      date: "May 08",
      issued: 82000,
      redeemed: 135000,
      refunded: 100000,
      pending: 30000,
      expired: 22000,
      reversed: 16000,
    },
    {
      date: "May 10",
      issued: 118000,
      redeemed: 170000,
      refunded: 135000,
      pending: 52000,
      expired: 20000,
      reversed: 20000,
    },
    {
      date: "May 12",
      issued: 130000,
      redeemed: 185000,
      refunded: 148000,
      pending: 70000,
      expired: 28000,
      reversed: 10000,
    },
    {
      date: "May 15",
      issued: 125000,
      redeemed: 182000,
      refunded: 145000,
      pending: 60000,
      expired: 22000,
      reversed: 14000,
    },
    {
      date: "May 19",
      issued: 120000,
      redeemed: 175000,
      refunded: 138000,
      pending: 90000,
      expired: 20000,
      reversed: 18000,
    },
    {
      date: "May 25",
      issued: 168000,
      redeemed: 222000,
      refunded: 185000,
      pending: 90000,
      expired: 20000,
      reversed: 16000,
    },
    {
      date: "May 28",
      issued: 158000,
      redeemed: 212000,
      refunded: 178000,
      pending: 90000,
      expired: 21000,
      reversed: 13000,
    },
    {
      date: "May 31",
      issued: 180000,
      redeemed: 235000,
      refunded: 200000,
      pending: 110000,
      expired: 22000,
      reversed: 9000,
    },
  ];

  const redemptionLegend = [
    { key: "issued", label: "Issued", color: "#04B22E" },
    { key: "redeemed", label: "Redeemed", color: "#000000" },
    { key: "refunded", label: "Refunded", color: "#7E1BAD" },
    { key: "pending", label: "Pending", color: "#FEB91E" },
    { key: "expired", label: "Expired", color: "#C40000" },
    { key: "reversed", label: "Reversed", color: "#696969" },
  ];

  const walletImpactData = [
    {
      icon: Wallet,
      iconBg: "#ECF9F7",
      iconColor: "#14B8A6",
      title: "Active Wallet Balance",
      value: "2,186,000 EGP",
      trend: "11.6%",
    },
    {
      icon: CreditCard,
      iconBg: "#F0F8FF",
      iconColor: "#3E9FF6",
      title: "Total Wallet Transactions",
      value: "18,542",
      trend: "8.3%",
    },
    {
      icon: ShoppingCart,
      iconBg: "#F4F8F0",
      iconColor: "#8CB369",
      title: "Wallet Redemption Orders",
      value: "7,842",
      trend: "9.1%",
    },
    {
      icon: Clock,
      iconBg: "#FFFAEA",
      iconColor: "#F59E0B",
      title: "Average Redemption Delay",
      value: "302 Days",
      trend: "6.7%",
    },
    {
      icon: Coins,
      iconBg: "#FFF4F0",
      iconColor: "#DC2626",
      title: "Unused Cashback",
      value: "512,450 EGP",
      trend: "6.7%",
    },
    {
      icon: Calendar,
      iconBg: "#F6E9FC",
      iconColor: "#7E1BAD",
      title: "Wallet Expiration Rate",
      value: "6.8%",
      trend: "6.7%",
    },
  ];

  const expiringSoonData = [
    {
      icon: Umbrella,
      bg: "#FFF7ED",
      iconColor: "#F59E0B",
      name: "Weekend Wallet Boost",
      liability: "125,000 EGP",
      days: "2 days",
    },
    {
      icon: Droplet,
      bg: "#FFFAEA",
      iconColor: "#F59E0B",
      name: "Oil Change Reward",
      liability: "125,000 EGP",
      days: "3 days",
    },
    {
      icon: Car,
      bg: "#EFF6FF",
      iconColor: "#65A30D",
      name: "10% Cashback on Maintenance",
      liability: "125,000 EGP",
      days: "5 days",
    },
    {
      icon: Car,
      bg: "#EFF6FF",
      iconColor: "#65A30D",
      name: "10% Cashback on Maintenance",
      liability: "125,000 EGP",
      days: "6 days",
    },
    {
      icon: Gift,
      bg: "#F6E9FC",
      iconColor: "#7E1BAD",
      name: "New User Cashback",
      liability: "125,000 EGP",
      days: "8 days",
    },
  ];

  return (
    <div className="voucher-page-wrapper">
      <div className="voucher-overview">
        {/* HEADER */}
        <div className="voucher-header">
          <div className="voucher-header-left">
            <h3>Cashback</h3>
            <p>
              Create and manage cashback campaigns that reward customers after
              orders are completed.
            </p>
          </div>
          <div className="header-right">
            <button className="incentive-btn create">
              <i className="fa-solid fa-plus"></i>
              Create Cashback
            </button>
            <button className="incentive-btn light">
              <i className="fa-solid fa-download"></i>
              Export
            </button>
          </div>
        </div>
        {/* STATS */}
        <div className="vouchers-stats-grid">
          {stats.map((item, i) => (
            <div className="vouchers-stat-card" key={i}>
              <div className="vouchers-stat-top-bundles">
                <div
                  className="vouchers-stat-icon"
                  style={{ backgroundColor: item.bg }}
                >
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="vouchers-stat-icon-img"
                  />
                </div>
                <span className="vouchers-stat-title">{item.title}</span>
              </div>

              <div className="vouchers-stat-value-bundles">{item.value}</div>

              <div className="vouchers-stat-bottom">
                {item.trend ? (
                  <>
                    <span
                      className={`vouchers-trend vouchers-trend-${item.trendType}`}
                    >
                      {item.trend}
                    </span>
                    <span className="vouchers-trend-text">{item.subtitle}</span>
                  </>
                ) : (
                  <span className="vouchers-trend-text">{item.subtitle}</span>
                )}
              </div>
            </div>
          ))}
        </div>
        {/* Bundles Performance */}
        <div className="vi-card mt-4">
          <h4 className="vi-card-title">
            Bundles Performance <span>(Last 30 Days)</span>{" "}
          </h4>
          <div className="bundles-impact-grid">
            {bundlesPerformance.map((item, i) => (
              <div className="bi-item" key={i}>
                <div
                  className="bi-icon-circle"
                  style={{ backgroundColor: item.color }}
                >
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="vouchers-stat-icon-img"
                  />
                </div>
                <div className="bi-content">
                  <span className="bi-label">{item.title}</span>
                  <div className="bi-value">{item.value}</div>
                  <div className="bi-trend">
                    <span className="bi-trend-arrow">
                      <ArrowUpRight size={10} />
                    </span>
                    <span className="bi-trend-pct">{item.trend}</span>
                    <span className="bi-trend-text">vs last 30 days</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* filters */}
        <div className="bf-wrapper my-3">
          <div className="bf-top-row">
            <div className="bf-search-box">
              <Search size={16} className="bf-search-icon" />
              <input
                type="text"
                placeholder="Search by campaign name, ID..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="bf-search-input"
              />
            </div>
            <div className="bf-actions">
              <button className="bf-clear-all" onClick={handleClearAll}>
                Clear all
              </button>
              <button
                className="bf-toggle-btn"
                onClick={() => setIsFiltersOpen((prev) => !prev)}
              >
                Filters
                {isFiltersOpen ? (
                  <ChevronUp size={14} />
                ) : (
                  <ChevronDown size={14} />
                )}
              </button>
            </div>
          </div>

          {isFiltersOpen && (
            <div className="bf-body">
              <div className="bf-grid-row">
                {filterFieldsRow1.map((field) => (
                  <div className="bf-field" key={field.key}>
                    <label className="bf-field-label">{field.label}</label>
                    <button className="bf-dropdown">
                      <span>{field.value}</span>
                      <ChevronDown size={14} />
                    </button>
                  </div>
                ))}
              </div>

              <div className="bf-grid-row">
                {filterFieldsRow2.map((field) => (
                  <div className="bf-field" key={field.key}>
                    <label className="bf-field-label">{field.label}</label>
                    <button className="bf-dropdown">
                      <span>{field.value}</span>
                      <ChevronDown size={14} />
                    </button>
                  </div>
                ))}
                <div className="bf-field">
                  <label className="bf-field-label">Date Range</label>
                  <button className="bf-dropdown bf-date-dropdown">
                    <span>{filters.dateRange}</span>
                    <Calendar size={14} />
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* VOUCHERS TABLE */}
        <div className="vouchers-table-section">
          <div className="vouchers-tabs-bar">
            {voucherTabs.map((tab) => (
              <button
                key={tab.key}
                className={`vouchers-tab ${
                  activeVoucherTab === tab.key ? "active" : ""
                }`}
                onClick={() => {
                  setActiveVoucherTab(tab.key);
                  setVoucherPage(1);
                  setSelectedRows(new Set());
                }}
              >
                {tab.label}{" "}
                <span className="vouchers-tab-count">{tab.count}</span>
              </button>
            ))}
          </div>
          <div className="vouchers-table-card">
            <div className="vouchers-table-header">
              <h3>{activeTabLabel}</h3>
              {selectedRows.size > 0 && (
                <div className="vouchers-bulk-actions">
                  <span className="vouchers-selected-count">
                    {selectedRows.size} selected
                  </span>
                  <span className="vouchers-bulk-divider">|</span>
                  <span className="vouchers-bulk-label">Bulk actions:</span>
                  <button className="vouchers-bulk-btn vouchers-bulk-activate">
                    <Check size={14} /> Activate
                  </button>
                  <button className="vouchers-bulk-btn vouchers-bulk-pause">
                    <Pause size={14} /> Pause
                  </button>
                  <button className="vouchers-bulk-btn vouchers-bulk-delete">
                    <Trash2 size={14} /> Delete
                  </button>
                  <button
                    className="vouchers-clear-selection"
                    onClick={() => setSelectedRows(new Set())}
                  >
                    <X size={14} /> Clear Selection
                  </button>
                </div>
              )}
            </div>
            <div className="vouchers-table-wrapper">
              <table className="vouchers-data-table">
                <thead>
                  <tr>
                    <th className="vouchers-checkbox-cell">
                      <input
                        type="checkbox"
                        checked={allSelected}
                        onChange={toggleSelectAll}
                      />
                    </th>
                    <th>ID</th>
                    <th>Code</th>
                    <th>Promo Name</th>
                    <th>Type</th>
                    <th>Discount</th>
                    <th>Usage Used/Limit</th>
                    <th>Status</th>
                    <th>Validity</th>
                    <th>Assigned To</th>
                    <th>Last Update</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentPageData.map((v) => {
                    const percent = v.redemptionLimit
                      ? Math.round((v.redemptionUsed / v.redemptionLimit) * 100)
                      : 0;
                    const barColor = percent > 80 ? "red" : "green";
                    const style = statusStyles[v.status] || {
                      bg: "#F3F4F6",
                      color: "#6B7280",
                    };
                    return (
                      <tr key={v.id}>
                        <td className="vouchers-checkbox-cell">
                          <input
                            type="checkbox"
                            checked={selectedRows.has(v.id)}
                            onChange={() => toggleRow(v.id)}
                          />
                        </td>
                        <td className="vouchers-id-cell">{v.id}</td>
                        <td>
                          <span className="vouchers-code-badge">{v.code}</span>
                        </td>
                        <td className="vouchers-name-cell">{v.name}</td>
                        <td>{v.type}</td>
                        <td>{v.discount}</td>
                        <td>
                          <div className="vouchers-remaining-cell">
                            <span>
                              {v.redemptionUsed.toLocaleString()} /{" "}
                              {v.redemptionLimit
                                ? v.redemptionLimit.toLocaleString()
                                : "Unlimited"}
                            </span>
                            {v.redemptionLimit && (
                              <div className="vouchers-remaining-bar-bg">
                                <div
                                  className={`vouchers-remaining-bar-fill vouchers-bar-${barColor}`}
                                  style={{ width: `${percent}%` }}
                                />
                              </div>
                            )}
                          </div>
                        </td>
                        <td>
                          <span
                            className="vouchers-status-badge"
                            style={{
                              backgroundColor: style.bg,
                              color: style.color,
                            }}
                          >
                            <span
                              className="vouchers-status-dot"
                              style={{ backgroundColor: style.color }}
                            />
                            {v.status}
                            <Info size={12} />
                          </span>
                        </td>
                        <td>{v.validity}</td>
                        <td>{v.assignedTo}</td>
                        <td className="vouchers-lastupdate-cell">
                          <div>{v.lastUpdate}</div>
                          <div className="vouchers-lastupdate-user">
                            {v.updatedBy}
                          </div>
                        </td>
                        <td className="vouchers-action-cell">
                          <FiMoreVertical
                            onClick={() => navigate(`/vouchers/${v.id}`)}
                            size={16}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="vouchers-table-footer">
              <span className="vouchers-showing-text">
                Showing {startIndex + 1} of{" "}
                {Math.min(startIndex + perPage, totalVouchersCount)} of{" "}
                {totalVouchersCount} promo codes
              </span>
              <div className="vouchers-footer-right">
                <select
                  className="vouchers-perpage-select"
                  value={perPage}
                  onChange={(e) => {
                    setPerPage(Number(e.target.value));
                    setVoucherPage(1);
                  }}
                >
                  <option value={10}>10 per page</option>
                  <option value={25}>25 per page</option>
                  <option value={50}>50 per page</option>
                </select>
                <div className="vouchers-pagination">
                  <button
                    className="vouchers-page-arrow"
                    disabled={voucherPage === 1}
                    onClick={() => setVoucherPage((p) => Math.max(1, p - 1))}
                  >
                    <ChevronLeft size={16} />
                  </button>

                  {pageNumbers.map((n, i) =>
                    n === "..." ? (
                      <span key={i} className="vouchers-page-ellipsis">
                        ...
                      </span>
                    ) : (
                      <button
                        key={i}
                        className={`vouchers-page-btn ${
                          voucherPage === n ? "active" : ""
                        }`}
                        onClick={() => setVoucherPage(n)}
                      >
                        {n}
                      </button>
                    ),
                  )}

                  <button
                    className="vouchers-page-arrow"
                    disabled={voucherPage === totalPages}
                    onClick={() =>
                      setVoucherPage((p) => Math.min(totalPages, p + 1))
                    }
                  >
                    <ChevronRight size={16} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* INSIGHTS SECTION */}
        <div className="cbi-main-layout">
          {/* ================= LEFT MASTER COLUMN ================= */}
          <div className="cbi-main-left">
            {/* TOP LEFT */}
            <div className="cbi-top-left">
              {/* Redemption Trend */}
              <div className="cbi-panel cbi-redemption-panel">
                <div className="cbi-panel-header">
                  <h4 className="cbi-panel-title">
                    Redemption Trend (Last 30 days)
                  </h4>

                  <button className="cbi-period-select">
                    <span>Last 30 days</span>
                    <ChevronDown size={14} />
                  </button>
                </div>

                <div className="cbi-redemption-legend">
                  {redemptionLegend.map((item) => (
                    <div className="cbi-redemption-legend-item" key={item.key}>
                      <span
                        className="cbi-redemption-legend-dot"
                        style={{ backgroundColor: item.color }}
                      />

                      <span className="cbi-redemption-legend-label">
                        {item.label}
                      </span>
                    </div>
                  ))}
                </div>

                <div className="cbi-redemption-chart">
                  <ResponsiveContainer width="100%" height={300}>
                    <ComposedChart
                      data={redemptionTrendData}
                      margin={{
                        top: 10,
                        right: 8,
                        left: 0,
                        bottom: 8,
                      }}
                    >
                      <CartesianGrid stroke="#E8E8E8" vertical horizontal />

                      <XAxis
                        dataKey="date"
                        tick={{
                          fontSize: 11,
                          fill: "#777",
                        }}
                        tickLine={false}
                        axisLine={false}
                      />

                      <YAxis
                        domain={[0, 250000]}
                        ticks={[0, 50000, 100000, 150000, 200000, 250000]}
                        tickFormatter={(value) =>
                          value === 0 ? "0" : `${value / 1000}K`
                        }
                        tick={{
                          fontSize: 11,
                          fill: "#777",
                        }}
                        tickLine={false}
                        axisLine={false}
                        width={35}
                      />

                      <Tooltip
                        formatter={(value) =>
                          `${Number(value).toLocaleString()} EGP`
                        }
                        contentStyle={{
                          border: "1px solid #E8E8E8",
                          borderRadius: "10px",
                          fontFamily: "Cairo",
                          fontSize: "12px",
                        }}
                      />

                      <Line
                        type="monotone"
                        dataKey="issued"
                        stroke="#04B22E"
                        strokeWidth={2}
                        dot={{
                          r: 4,
                          fill: "#fff",
                          stroke: "#04B22E",
                          strokeWidth: 2,
                        }}
                        activeDot={{ r: 5 }}
                      />

                      <Line
                        type="monotone"
                        dataKey="redeemed"
                        stroke="#000000"
                        strokeWidth={2}
                        dot={{
                          r: 4,
                          fill: "#fff",
                          stroke: "#000000",
                          strokeWidth: 2,
                        }}
                        activeDot={{ r: 5 }}
                      />

                      <Line
                        type="monotone"
                        dataKey="refunded"
                        stroke="#7E1BAD"
                        strokeWidth={2}
                        dot={{
                          r: 4,
                          fill: "#fff",
                          stroke: "#7E1BAD",
                          strokeWidth: 2,
                        }}
                        activeDot={{ r: 5 }}
                      />

                      <Line
                        type="monotone"
                        dataKey="pending"
                        stroke="#FEB91E"
                        strokeWidth={2}
                        dot={{
                          r: 4,
                          fill: "#fff",
                          stroke: "#FEB91E",
                          strokeWidth: 2,
                        }}
                        activeDot={{ r: 5 }}
                      />

                      <Line
                        type="monotone"
                        dataKey="expired"
                        stroke="#C40000"
                        strokeWidth={2}
                        dot={{
                          r: 4,
                          fill: "#fff",
                          stroke: "#C40000",
                          strokeWidth: 2,
                        }}
                        activeDot={{ r: 5 }}
                      />

                      <Line
                        type="monotone"
                        dataKey="reversed"
                        stroke="#696969"
                        strokeWidth={2}
                        dot={{
                          r: 4,
                          fill: "#fff",
                          stroke: "#696969",
                          strokeWidth: 2,
                        }}
                        activeDot={{ r: 5 }}
                      />
                    </ComposedChart>
                  </ResponsiveContainer>
                </div>
              </div>
              {/* Top Performing Campaigns */}
              <div className="cbi-panel cbi-performing-table-panel">
                <div className="cbi-panel-header">
                  <h4 className="cbi-panel-title">Top Performing Campaigns</h4>

                  <span className="cbi-view-all">
                    View all <ArrowRight size={14} />
                  </span>
                </div>

                <div className="cbi-performing-table">
                  <div className="cbi-performing-head">
                    <span className="cbi-performing-head-first">Campaign</span>
                    <span>Revenue (EGP)</span>
                    <span>ROI</span>
                    <span>Repeat Rate</span>
                    <span>Redemption %</span>
                  </div>

                  {[
                    {
                      icon: Car,
                      bg: "#EFF6FF",
                      iconColor: "#65A30D",
                      name: "10% Cashback on Maintenance",
                    },
                    {
                      icon: Umbrella,
                      bg: "#FFF7ED",
                      iconColor: "#F59E0B",
                      name: "Weekend Wallet Boost",
                    },
                    {
                      icon: Droplet,
                      bg: "#FFFAEA",
                      iconColor: "#F59E0B",
                      name: "Oil Change Reward",
                    },
                    {
                      icon: Droplet,
                      bg: "#FFFAEA",
                      iconColor: "#F59E0B",
                      name: "Oil Change Reward",
                    },
                    {
                      icon: Gift,
                      bg: "#FFF4F0",
                      iconColor: "#DC2626",
                      name: "Battery Cashback",
                    },
                  ].map((item, i) => {
                    const PIcon = item.icon;

                    return (
                      <div className="cbi-performing-row" key={i}>
                        <div className="cbi-performing-campaign">
                          <div
                            className="cbi-performing-icon"
                            style={{
                              backgroundColor: item.bg,
                            }}
                          >
                            <PIcon size={14} color={item.iconColor} />
                          </div>

                          <span>{item.name}</span>
                        </div>

                        <strong>125,000 EGP</strong>

                        <span>3.8x</span>

                        <span>24.2%</span>

                        <span>66.4%</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            {/* MIDDLE LEFT */}
            <div className="cbi-row-2col">
              <div className="cbi-panel">
                <div className="cbi-panel-header">
                  <h4 className="cbi-panel-title">
                    Campaigns Status Distrubution
                  </h4>
                </div>
                <div className="cbi-donut-row">
                  <div
                    className="cbi-donut-wrapper"
                    style={{
                      background: buildConicGradient(campaignStatusData),
                    }}
                  >
                    <div className="cbi-donut-hole">
                      <span className="cbi-donut-total">
                        {campaignStatusTotal}
                      </span>

                      <span className="cbi-donut-total-label">Total</span>
                    </div>
                  </div>

                  <div className="cbi-donut-legend">
                    {campaignStatusData.map((s, i) => (
                      <div className="cbi-legend-row" key={i}>
                        <span
                          className="cbi-legend-dot"
                          style={{
                            backgroundColor: s.color,
                          }}
                        />

                        <span className="cbi-legend-label">
                          {s.label} ({s.count})
                        </span>

                        <span className="cbi-legend-pct">{s.pct}%</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="cbi-panel">
                <div className="cbi-panel-header">
                  <h4 className="cbi-panel-title">Campaign Health</h4>
                </div>

                <div className="cbi-health-list">
                  {campaignHealthData.map((h, i) => {
                    const HIcon = h.icon;

                    return (
                      <div className="cbi-health-row" key={i}>
                        <div className="cbi-health-top">
                          <div className="cbi-health-left">
                            <div
                              className="cbi-health-icon-circle"
                              style={{
                                backgroundColor: h.iconBg,
                              }}
                            >
                              <HIcon size={18} color={h.iconColor} />
                            </div>

                            <div className="cbi-health-titles">
                              <span className="cbi-health-title">
                                {h.title}
                              </span>

                              <span className="cbi-health-desc">{h.desc}</span>
                            </div>
                          </div>

                          <span
                            className="cbi-health-badge"
                            style={{
                              backgroundColor: h.badgeBg,
                              color: h.badgeColor,
                            }}
                          >
                            {h.badge}
                          </span>
                        </div>

                        <div className="cbi-health-bar-track">
                          <div
                            className="cbi-health-bar-fill"
                            style={{
                              width: `${h.barWidth}%`,
                              backgroundColor: h.barColor,
                            }}
                          />
                        </div>

                        <div className="cbi-health-bottom">
                          <span className="cbi-health-fraction">
                            {h.fraction}
                          </span>

                          <span className="cbi-health-pct">{h.pctLabel}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="cbi-row-2col">
              <div className="cbi-panel">
                <div className="cbi-panel-header">
                  <h4 className="cbi-panel-title">Top Cashback Categories</h4>
                </div>

                <div className="cbi-donut-row">
                  <div
                    className="cbi-donut-wrapper cbi-donut-small"
                    style={{
                      background: buildConicGradient(topCategoriesData),
                    }}
                  >
                    <div className="cbi-donut-hole" />
                  </div>

                  <div className="cbi-donut-legend">
                    {topCategoriesData.map((s, i) => (
                      <div className="cbi-legend-row" key={i}>
                        <span
                          className="cbi-legend-dot"
                          style={{
                            backgroundColor: s.color,
                          }}
                        />

                        <span className="cbi-legend-label">{s.label}</span>

                        <span className="cbi-legend-pct">({s.pct}%)</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="cbi-metric-grid">
                {cashbackMetricCards.map((m, i) => {
                  const MIcon = m.icon;

                  return (
                    <div className="cbi-metric-card" key={i}>
                      <div className="cbi-metric-top">
                        <div
                          className="cbi-metric-icon-circle"
                          style={{
                            backgroundColor: m.bg,
                          }}
                        >
                          <MIcon size={16} color={m.iconColor} />
                        </div>

                        <span className="cbi-metric-title">{m.title}</span>
                      </div>

                      <div className="cbi-metric-value">
                        <span className="cbi-metric-value-num">{m.count}</span>{" "}
                        Campaigns
                      </div>

                      <div
                        className={`cbi-metric-trend cbi-metric-trend-${m.trendType}`}
                      >
                        {m.trendType === "up" ? (
                          <ArrowUpRight size={10} />
                        ) : (
                          <ArrowDown size={10} />
                        )}

                        <span className="cbi-metric-trend-pct">{m.trend}</span>

                        <span className="cbi-metric-trend-text">
                          vs last 30 days
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            {/* Abuse Detection */}
            <div className="cbi-panel">
              <div className="cbi-panel-header">
                <h4 className="cbi-panel-title">Cashback Abuse Detection</h4>

                <div className="cbi-period-select">
                  <span>Last 30 days</span>
                  <ChevronDown size={14} />
                </div>
              </div>

              <div className="cbi-abuse-table">
                <div className="cbi-abuse-head-row">
                  <span>Abuse Type</span>
                  <span>Description</span>
                  <span>Cases</span>
                  <span>Risk Level</span>
                </div>

                {abuseDetectionData.map((a, i) => {
                  const AIcon = a.icon;

                  return (
                    <div className="cbi-abuse-row" key={i}>
                      <div className="cbi-abuse-type">
                        <div
                          className="cbi-abuse-icon-circle"
                          style={{
                            backgroundColor: a.bg,
                          }}
                        >
                          <AIcon size={16} color={a.iconColor} />
                        </div>

                        <span>{a.type}</span>
                      </div>

                      <span className="cbi-abuse-desc">{a.desc}</span>

                      <div className="cbi-abuse-cases">
                        <span className="cbi-abuse-cases-num">{a.cases}</span>

                        <span className="cbi-abuse-cases-trend">
                          <ArrowDown size={10} /> {a.trendPct} vs last 30 days
                        </span>
                      </div>

                      <span
                        className="cbi-risk-pill"
                        style={{
                          backgroundColor: a.riskBg,
                          color: a.riskColor,
                        }}
                      >
                        {a.riskLevel}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          {/* ================= RIGHT MASTER COLUMN ================= */}
          <div className="cbi-main-right">
            {/* Wallet Impact */}
            <div className="cbi-panel cbi-wallet-impact-panel">
              <div className="cbi-panel-header">
                <h4 className="cbi-panel-title">Wallet Impact</h4>
              </div>

              <div className="cbi-wallet-impact-list">
                {walletImpactData.map((item, i) => {
                  const WIcon = item.icon;

                  return (
                    <div className="cbi-wallet-impact-item" key={i}>
                      <div
                        className="cbi-wallet-impact-icon"
                        style={{
                          backgroundColor: item.iconBg,
                        }}
                      >
                        <WIcon size={17} color={item.iconColor} />
                      </div>

                      <div className="cbi-wallet-impact-content">
                        <span className="cbi-wallet-impact-title">
                          {item.title}
                        </span>

                        <strong className="cbi-wallet-impact-value">
                          {item.value}
                        </strong>

                        <span className="cbi-wallet-impact-trend">
                          <ArrowUpRight size={10} />
                          {item.trend}
                          <span>vs last 30 days</span>
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            {/* Expiring Soon */}
            <div className="cbi-panel cbi-expiring-panel">
              <div className="cbi-panel-header">
                <h4 className="cbi-panel-title">Expiring Soon (Cashback)</h4>

                <span className="cbi-view-all">
                  View all <ArrowRight size={14} />
                </span>
              </div>

              <div className="cbi-expiring-head">
                <span>Campaign</span>
                <span>Remaining Liability</span>
                <span>Expiration</span>
              </div>

              <div className="cbi-expiring-list">
                {expiringSoonData.map((item, i) => {
                  const EIcon = item.icon;

                  return (
                    <div className="cbi-expiring-row" key={i}>
                      <div className="cbi-expiring-campaign">
                        <div
                          className="cbi-expiring-icon"
                          style={{
                            backgroundColor: item.bg,
                          }}
                        >
                          <EIcon size={14} color={item.iconColor} />
                        </div>

                        <span>{item.name}</span>
                      </div>

                      <strong>{item.liability}</strong>

                      <span className="cbi-expiring-days">{item.days}</span>
                    </div>
                  );
                })}
              </div>
            </div>
            {/* Top Performing Campaigns */}
            <div className="cbi-panel">
              <div className="cbi-panel-header">
                <h4 className="cbi-panel-title">Top Performing Campaigns</h4>
                <span className="cbi-view-all">
                  View all <ArrowRight size={14} />
                </span>
              </div>
              <div className="cbi-value-list">
                {topPerformingCampaignsList.map((item, i) => {
                  const TIcon = item.icon;
                  return (
                    <div className="cbi-value-row" key={i}>
                      <div className="cbi-value-left">
                        <div
                          className="cbi-value-icon-circle"
                          style={{
                            backgroundColor: item.bg,
                          }}
                        >
                          <TIcon size={15} color={item.iconColor} />
                        </div>

                        <span className="cbi-value-name">{item.name}</span>
                      </div>

                      <div className="cbi-value-right">
                        <span className="cbi-value-amount">{item.amount}</span>

                        <span className="cbi-value-pct">{item.pct}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            {/* Wallet Funnel */}
            <div className="cbi-panel">
              <div className="cbi-panel-header">
                <h4 className="cbi-panel-title">Wallet Funnel</h4>
              </div>
              <div className="cbi-funnel-wrap">
                <div className="cbi-funnel-chart">
                  {walletFunnelData.map((f, i) => {
                    const topWidth = walletFunnelWidths[i];
                    const bottomWidth = walletFunnelWidths[i + 1] ?? 10;

                    return (
                      <div
                        key={i}
                        className="cbi-funnel-bar"
                        style={{
                          "--cbi-funnel-top": `${topWidth}%`,
                          "--cbi-funnel-bottom": `${bottomWidth}%`,
                          backgroundColor: f.color,
                        }}
                      />
                    );
                  })}
                </div>

                <div className="cbi-funnel-legend">
                  {walletFunnelData.map((f, i) => (
                    <div className="cbi-funnel-legend-row" key={i}>
                      <span
                        className="cbi-legend-dot"
                        style={{
                          backgroundColor: f.color,
                        }}
                      />

                      <span className="cbi-funnel-legend-label">{f.label}</span>

                      <span className="cbi-funnel-legend-amount">
                        {f.amount}
                      </span>

                      <span className="cbi-funnel-legend-pct">{f.pct}%</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {/* Settlement Overview */}
            <div className="cbi-panel">
              <div className="cbi-panel-header">
                <h4 className="cbi-panel-title">Settlement Overview</h4>
              </div>

              <div className="cbi-settlement-list">
                {settlementOverviewData.map((s, i) => {
                  const SIcon = s.icon;

                  return (
                    <div className="cbi-settlement-row" key={i}>
                      <div
                        className="cbi-settlement-icon-circle"
                        style={{
                          backgroundColor: s.bg,
                          color: s.iconColor,
                        }}
                      >
                        {s.letter ? (
                          s.letter
                        ) : (
                          <SIcon size={16} color={s.iconColor} />
                        )}
                      </div>

                      <div className="cbi-settlement-body">
                        <div className="cbi-settlement-top">
                          <span className="cbi-settlement-title">
                            {s.title}
                          </span>

                          <span className="cbi-settlement-amount">
                            {s.amount}
                          </span>

                          <span className="cbi-settlement-pct">{s.pct}%</span>
                        </div>

                        <div className="cbi-settlement-bar-track">
                          <div
                            className="cbi-settlement-bar-fill"
                            style={{
                              width: `${s.pct}%`,
                              backgroundColor: s.barColor,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        {/* ================= FULL WIDTH ================= */}
        <div className="cbi-full-width-section">
          <div className="cbi-panel cbi-recent-activity-panel">
            <div className="cbi-panel-header">
              <h4 className="cbi-panel-title">Recent Activity</h4>

              <span className="cbi-view-all">
                View all <ArrowRight size={14} />
              </span>
            </div>

            <div className="cbi-activity-table">
              <div className="cbi-activity-head-row">
                <span>User</span>
                <span>Action</span>
                <span>Campaign</span>
                <span>Date</span>
                <span>Source</span>
                <span>Details</span>
              </div>

              {cashbackRecentActivity.map((r, i) => (
                <div className="cbi-activity-row" key={i}>
                  <div className="cbi-activity-user">
                    <img
                      src={r.avatar}
                      alt={r.user}
                      className="cbi-activity-avatar"
                    />

                    <div className="cbi-activity-user-text">
                      <span className="cbi-activity-user-name">{r.user}</span>

                      <span className="cbi-activity-user-role">{r.role}</span>
                    </div>
                  </div>

                  <span>{r.action}</span>

                  <span>{r.campaign}</span>

                  <div className="cbi-activity-date">
                    <span>{r.date}</span>
                    <span>{r.time}</span>
                  </div>

                  <span>{r.source}</span>

                  <span className="cbi-activity-details">{r.details}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
